import {
	AfterViewInit,
	Component,
	ComponentFactoryResolver,
	ElementRef,
	EventEmitter,
	Injector,
	Input,
	OnInit,
	Output,
	Renderer2,
	ViewChild,
	ViewContainerRef,
	ViewEncapsulation,
} from '@angular/core';
import { assign, forEach, get, includes, isEmpty, isUndefined, isArray } from 'lodash';
import { formatNumberWithCommas, getComponentName } from '../../../Utils/utils';

import { ActionApiService } from '../../../Services/action-api/action-api.service';
import { Layoutresolver } from '../../../Services/layout/layout-resolver';
import { ObservablesService } from '../../../Services/observables/observables';
import { StoreService } from '../../../Services/store';
import { Subscription } from 'rxjs';
import { PagesDurationService } from 'src/app/Services/pages-duration/pages-duration.service';
import { componentMap } from '../../Components';
import { LayoutService } from 'src/app/Services/layout/layout.service';

@Component({
	selector: 'control',
	encapsulation: ViewEncapsulation.None,
	template: `
		<div class="control-container" [ngClass]="relevantClass">
			<fieldset
				[ngClass]="{
					'prior-address-wrapper': control && control.attributes && control.attributes.wrapperBox
				}"
			>
				<legend class="legend-text" [innerHtml]="legend"></legend>

				<question
					*ngIf="control.title"
					[error]="error"
					[name]="control.name"
					[title]="control.title"
					[subtitle]="control.subtitle"
					[attributes]="control.attributes"
					[ngClass]="{ error: error, vAlign: vAlignMiddle() }"
					[tooltip]="control.tooltip"
				></question>
				<div
					class="control"
					[ngClass]="{
						'full-width': !control.title,
						vAlign: vAlignMiddle(),
						error: error && !isArray(this.error)
					}"
					[class]="control.attributes && control.attributes.class"
				>
					<ng-container #container></ng-container>
				</div>

				<div *ngIf="isAuditingVisible()" class="audit-wrap audit-wrap-{{ control.controlType }}">
					<auditing
						[type]="auditing.type"
						[auditIcon]="getAuditIcon()"
						[filledData]="TEMPORARY_FUNCTION_FORMAT_AUDITING_DATA()"
						[indicator]="auditing.indicator"
					></auditing>
				</div>
			</fieldset>
		</div>
	`,
	styleUrls: ['./control-custom-styles.scss', './control-container.scss', './control.scss'],
})
export class ControlComponent implements OnInit, AfterViewInit {
	@Input() control: control;
	@Input() data: any;
	@Input() context: any;
	@Input() componentClass: any;
	@Input() isLast;
	boolean;
	setAnswer: any;
	setInitialAnswer: any;
	ajaxAction: any;
	updateData: any;
	getAnswers: any;
	class: any;
	error: any;
	@Input() value: any;
	auditing: any;
	request: request;
	style: string;
	layoutresolver: Layoutresolver;
	layoutService: LayoutService;
	relevantClass: any;
	parentControl: any;
	parentContext: any;
	legend: string;
	updateBindingSubscription: Subscription;

	@ViewChild('container', { static: true, read: ViewContainerRef }) container;
	@Output() allControlsGenerated: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private el: ElementRef,
		private storeService: StoreService,
		private actionService: ActionApiService,
		private observablesService: ObservablesService,
		private renderer: Renderer2,
		private pagesDurationService: PagesDurationService,
		injector: Injector
	) {
		this.layoutService = injector.get(LayoutService);
	}

	resolveComponentsFactory(componentName: string) {
		const componentType = componentMap[getComponentName(componentName)];

		if (isUndefined(componentType)) {
			return undefined;
		}
		return this.componentFactoryResolver.resolveComponentFactory(componentType);
	}

	ngOnInit() {
		if (
			!this.control.controls ||
			includes(['ExtendedInfoWeFound', 'QuestionGroup', 'Address', 'AddressDisplayDr'], this.control.controlType)
		) {
			if (this.control.visible) {
				this.createComponent(this.control, this.context);
			}
		} else {
			this.parentControl = this.control;
			this.parentContext = this.context;
			forEach(this.control.controls, (c) => c.visible && this.createComponent(c, this.context));
			this.error = this.storeService.getError(this.control, this.context);
		}
		const globalAttributes = this.storeService.getGlobalAttributes();

		setTimeout(() => {
			this.el.nativeElement.addEventListener('mouseenter', (e) => {
				let parent = null;

				if (e.target.tagName === 'CONTROL') {
					parent = e.target;
				} else {
					parent = this.getParentControl(e.target);
				}

				if (parent) {
					this.renderer.setAttribute(parent, 'data-hover', 'true');
				}
			});
			this.el.nativeElement.addEventListener('mouseleave', (e) => {
				let parent = null;

				if (e.target.tagName === 'CONTROL') {
					parent = e.target;
				} else {
					parent = this.getParentControl(e.target);
				}

				if (parent) {
					this.renderer.removeAttribute(parent, 'data-hover');
				}
			});
		}, 0);
		this.relevantClass = this.SetType();
		this.legend = this.getLegend();
	}

	ngAfterViewInit() {
		if (this.isLast) {
			this.allControlsGenerated.emit();
		}
	}

	isArray(arr: []) {
		return isArray(arr);
	}

	getParentControl(elem) {
		let thisParent = this.el.nativeElement(elem).parent();
		while (!thisParent[0].tagName || thisParent[0].tagName !== 'CONTROL') {
			thisParent = this.getParentControl(thisParent);
			if (!thisParent || (thisParent[0].tagName && thisParent[0].tagName === 'BODY')) {
				return null;
			}
		}
		return thisParent;
	}

	childCreate(name: any) {
		if (this.control.name === name) {
			this.createComponent(this.control, this.context);
		}
	}

	createComponent(control: control, context: string) {
		const factory = this.resolveComponentsFactory(control.controlType);
		if (isUndefined(factory)) {
			return;
		}
		const component = this.container.createComponent(factory);
		this.value = this.storeService.getValue(control.name, context);
		this.error = this.storeService.getError(control, context);
		const temp = this.storeService.getAuditing(control, context);
		if (temp) {
			this.auditing = temp;
		}
		this.componentClass = get(control, 'attributes.class');
		if (control.attributes && control.attributes.style) {
			this.style = control.attributes.style;
		}

		Object.assign(component.instance, {
			control: control,
			context: context,
			value: this.value,
			error: this.error,
			auditing: this.auditing,
			Class: this.componentClass,
			setAnswer: this._setAnswer,
			setInitialAnswer: this.setInitialAnswer,
			ajaxAction: this._ajaxAction,
			name: control.name,
			style: this.style,
			updateBinding: this.updateBinding(component.instance),
			parentControl: this.parentControl,
		});

		// update data after getting new json for the same stage (errors or relevancy or dit/view mode)
		this.updateBindingSubscription = this.observablesService.UpdateBinding.subscribe((controls: control[]) => {
			if (
				!this.control.controls ||
				includes(['ExtendedInfoWeFound', 'QuestionGroup', 'Address'], this.control.controlType)
			) {
				this.value = this.storeService.getValue(this.control.name, this.context);
				this.auditing = this.storeService.getAuditing(this.control, this.context);
			}
			if (this.control.controlType == 'QuoteWithInfoProvider') {
				this.control = controls.find((c) => c.controlType == 'QuoteWithInfoProvider');
			}
			if (this.control.name == 'CustomHtml.Disclaimer') {
				this.control = controls.find((c) => c.name == 'CustomHtml.Disclaimer');
			}
		});
	}

	updateBinding(data: any) {
		const self = data;
		this.observablesService.UpdateBinding.subscribe(() => {
			if (this.control.name) {
				this.error = this.storeService.getError(this.control, this.context);
				this.value = this.storeService.getValue(this.control.name, this.context);
				this.auditing = this.storeService.getAuditing(this.control, this.context);
			}
		});

		if (this.control.controlType === 'Address') {
			this.observablesService.addressChanged.subscribe(() => {
				if (this.control.name) {
					this.error = this.storeService.getError(this.control, this.context);
					this.value = this.storeService.getValue(this.control.name, this.context);
					this.auditing = this.storeService.getAuditing(this.control, this.context);
				}
			});
		}

		if (
			this.control.controlType === 'Control' &&
			this.control.controls &&
			this.control.attributes &&
			this.control.attributes.infoWeFoundMvp
		) {
			forEach(this.control.controls, (control) => {
				var error = this.storeService.getError(control, this.context);
				if (error) {
					this.error = error;
				}
			});
		}
	}

	setDataBindings(data: any) {
		assign(this, this.getControlBindings(data, this.control, this.context));
		this.updateBinding(data);
	}

	getControlBindings(data: any, control: control, context: string) {
		return {
			control: this.storeService.getControl(this.control.name, this.control.controlType, this.context),
			context,
			setAnswer: this._setAnswer,
			ajaxAction: this._ajaxAction,
			auditing: this.storeService.getAuditing(this.control, this.context),
			error: this.storeService.getError(this.control, this.context),
			value: this.storeService.getValue(this.control.name, this.context),
		};

		// data.control = this.storeService.getControl(this.control.name, this.context);
		// data.error = this.storeService.getError(this.control, this.context);
		// data.value = this.storeService.getValue(this.control.name, this.context);
		// data.auditing = this.storeService.getAuditing(this.control, this.context);
	}

	async _setAnswer(value, updatePage: boolean) {
		const { name, ajaxInfo } = this.control;
		const globalAttr = this.storeService.getGlobalAttributes();
		this.storeService.updateData(name, value, this.context);
		var addressState = this.storeService.getValue('PolicyData.PropertyAddress.State', this.context);
		addressState = addressState ? addressState : globalAttr['quoteState'];

		//check if the address is in FL
		if (addressState && addressState == 'FL') {
			const dependencyMap = {
				'PolicyData.PL_PoolFeatures_4ftFence': 'PolicyData.PL_HotTubFeatures_4ftFence',
				'PolicyData.PL_HotTubFeatures_4ftFence': 'PolicyData.PL_PoolFeatures_4ftFence',
				'PolicyData.PL_PoolFeatures_ScreenEnclosure': 'PolicyData.PL_HotTubFeatures_ScreenEnclosure',
				'PolicyData.PL_HotTubFeatures_ScreenEnclosure': 'PolicyData.PL_PoolFeatures_ScreenEnclosure',
				'PolicyData.PL_PoolFeatures_SurroundingWall': 'PolicyData.PL_HotTubFeatures_SurroundingWall',
				'PolicyData.PL_HotTubFeatures_SurroundingWall': 'PolicyData.PL_PoolFeatures_SurroundingWall',
			};

			if (dependencyMap[name]) {
				this.storeService.updateData(dependencyMap[name], value, this.context);
			}

			const structurePairs = [
				{
					parent: 'PolicyData.PL_AdditionalStructures_Pool',
					child: 'PolicyData.PL_AdditionalStructures_HotTub',
					features: ['4ftFence', 'ScreenEnclosure', 'SurroundingWall'],
				},
				{
					parent: 'PolicyData.PL_AdditionalStructures_HotTub',
					child: 'PolicyData.PL_AdditionalStructures_Pool',
					features: ['4ftFence', 'ScreenEnclosure', 'SurroundingWall'],
				},
			];

			structurePairs.forEach(({ parent, child, features }) => {
				if (name === parent && value === true) {
					const childChecked = this.storeService.getValue(child, this.context);
					if (childChecked) {
						features.forEach((feature) => {
							const hotTubFeature = `PolicyData.PL_HotTubFeatures_${feature}`;
							const poolFeature = `PolicyData.PL_PoolFeatures_${feature}`;
							this.storeService.updateData(
								name.includes('Pool') ? poolFeature : hotTubFeature,
								this.storeService.getValue(name.includes('Pool') ? hotTubFeature : poolFeature, this.context),
								this.context
							);
						});
					}
				}
			});

			this.layoutService.staticLayout.subscribe((data) => {
				if (data && data.data.metadata.page.stage == 'Exterior') {
					const pool = this.storeService.getValue('PolicyData.PL_AdditionalStructures_Pool', this.context);
					const hotTub = this.storeService.getValue('PolicyData.PL_AdditionalStructures_HotTub', this.context);

					if (pool && hotTub) {
						const features = ['4ftFence', 'ScreenEnclosure', 'SurroundingWall'];

						features.forEach((feature) => {
							const hotTubFeature = `PolicyData.PL_HotTubFeatures_${feature}`;
							const poolFeature = `PolicyData.PL_PoolFeatures_${feature}`;

							const hotTubFeatureValue = this.storeService.getValue(hotTubFeature, this.context);
							const poolFeatureValue = this.storeService.getValue(poolFeature, this.context);
							if (hotTubFeatureValue) {
								this.storeService.updateData(poolFeature, hotTubFeatureValue, this.context);
							} else if (poolFeatureValue) {
								this.storeService.updateData(hotTubFeature, poolFeatureValue, this.context);
							}
						});
					}
				}
			});
		}

		if (!isEmpty(ajaxInfo) && !isEmpty(ajaxInfo.action)) {
			this.request = Object.assign(
				{},
				{
					data: this.storeService.getAnswers(this.context),
					info: ajaxInfo,
				}
			);

			if (ajaxInfo.action === 'PreSubmissionLoader' && !globalAttr['viewMode']) {
				this.pagesDurationService.calculateDisplayTime('Owners');
				this.request.data = { ...this.request.data, ...{ durations: this.pagesDurationService.durations } };
			}

			await this.actionService.invokeAction(this.request, true).then((res) => {
				if (updatePage) {
					this.observablesService.pageUpdated.next(this.context);
				}
			});
		} else {
			if (updatePage) {
				this.observablesService.pageUpdated.next(this.context);
			}
		}
	}

	async _ajaxAction() {
		this.control.ajaxInfo.elementSrc = this.control.name;
		this.request = Object.assign(
			{},
			{
				data: this.storeService.getAnswers(this.context),
				info: this.control.ajaxInfo,
			}
		);
		return await this.actionService.invokeAction(this.request, true);
	}

	SetType() {
		const res = {
			hideControl: this.hideControl(),
			nextbtn: this.isNextBtn(),
			'title-margin': this.setTitleMargin(),
			'title-margin-save-for-later': this.setTitleMarginSaveForLater(),
			'drp-down': this.isDropDown(),
			questionGroup: this.isQuestionGroup(),
			'task-control': this.isTaskControl(),
			'heads-up': this.isHeadsUp(),
			'secondary-online-buy': this.isSecondaryOnlineBuy(),
			'buying-options': this.isBuyingOptions(),
			'click-listening': this.isClickListening(),
			'coverage-package': this.setCoveragePackage(),
			'coverage-package-empty': this.setCoveragePackageEmpty(),
			'set-info-title-margin': this.isSetInfoTitleMargin(),
		};
		return Object.assign(res, this.addParentClass());
	}

	isHeadsUp() {
		if (this.control.controlType === 'Radio') {
			return (
				this.control.attributes && this.control.attributes.type && this.control.attributes.type.indexOf('heads-up') > -1
			);
		}
	}

	isSecondaryOnlineBuy() {
		if (this.control.controlType === 'SecondaryOnlineBuy') {
			return (
				this.control.attributes &&
				this.control.attributes.type &&
				this.control.attributes.type.indexOf('secondary-online-buy') > -1
			);
		}
	}

	isBuyingOptions() {
		if (this.control.controlType === 'buying-options') {
			return true;
		}
	}
	isClickListening() {
		if (this.control.controlType === 'ClickListening') {
			return true;
		}
	}
	setCoveragePackage() {
		if (this.control.controlType === 'CoveragePackages') {
			return true;
		}
	}

	setCoveragePackageEmpty() {
		if (this.control.controlType === 'CoveragePackages' && isEmpty(this.control.options)) {
			return true;
		}
	}

	hideControl() {
		switch (this.control.controlType) {
			case 'InfoWeFound':
				return isEmpty(this.storeService.getDynamicContent(`InfoWeFound.${this.control.name}`));
			case 'CustomeScriptInjectionHtml':
				return this.control.attributes.hideControl;
		}
	}

	isSetInfoTitleMargin() {
		const res = this.control.attributes && this.control.attributes.setInfoTitleMargin;
		return res;
	}

	isTaskControl() {
		if (
			!isEmpty(this.control.attributes) &&
			!isEmpty(this.control.attributes.class) &&
			this.control.attributes.class.indexOf('inline') > -1
		) {
			return true;
		}
	}

	isNextBtn() {
		if (this.control.controlType === 'CustomButton') {
			return this.control.attributes.type && this.control.attributes.type.indexOf('next') > -1;
		}
	}

	setTitleMargin() {
		if (this.control.controlType === 'SectionTitle' || this.control.controlType === 'Sep') {
			return true;
		}
	}

	addParentClass() {
		if (this.control.attributes && this.control.attributes.parentClass) {
			return { [this.control.attributes.parentClass]: true };
		}
		return {};
	}

	setTitleMarginSaveForLater() {
		if (this.control.controlType === 'SectionTitle' && this.control.attributes.class === 'save-for-later') {
			return true;
		}
	}

	isDropDown() {
		if (this.control.controlType === 'Dropdown') {
			return true;
		}
	}

	isQuestionGroup() {
		if (this.control.controlType === 'QuestionGroup') {
			return true;
		}
	}

	vAlignMiddle() {
		const isCheckboxGroup =
			this.control.controls && this.control.controls.length > 0 && this.control.controls[0].controlType === 'Checkbox';

		return (
			this.control.controlType === 'MaskedInput' ||
			this.control.controlType === 'UnmaskedInput' ||
			this.control.controlType === 'NumericStepper' ||
			this.control.controlType === 'Dropdown' ||
			this.control.controlType === 'Datepicker' ||
			(this.control.controlType === 'Control' && !isCheckboxGroup) ||
			this.control.controlType === 'Address'
		);
	}

	isAuditingVisible() {
		return (
			this.auditing &&
			!includes(['InfoWeFound', 'SectionTitle', 'SubSectionTitle', 'Sep', 'QuestionGroup'], this.control.controlType)
		);
	}

	getAuditIcon() {
		return this.auditing.type === 'default' ? 'default' : 'cog';
	}

	TEMPORARY_FUNCTION_FORMAT_AUDITING_DATA() {
		if (get(this.control, 'attributes.groupDigits')) {
			return formatNumberWithCommas(Number(this.auditing.filledData));
		} else {
			// get the parentControl audit and if is not undefind return the parentControl.filledData else return the current control filledData
			const parentAudit = this.storeService.getAuditing(this.parentControl, this.parentContext);
			return parentAudit !== undefined ? parentAudit.filledData : this.auditing.filledData;
		}
	}

	getLegend(): string {
		return (
			(!isEmpty(this.control.title) ? this.control.title : '') +
			(!isEmpty(this.control.subtitle) ? '<span>' + this.control.subtitle + '</span>' : '')
		);
	}

	ngOnDestroy() {
		this.updateBindingSubscription.unsubscribe();
	}
}
